import { render, staticRenderFns } from "./Alumns.vue?vue&type=template&id=4ff389bc&"
import script from "./Alumns.vue?vue&type=script&lang=js&"
export * from "./Alumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports